import { makeStyles, createStyles } from '@material-ui/core/styles'

interface StyleProps {
  headerVariant: 'primary' | 'secondary'
}

export const useStyles = makeStyles((theme) =>
  createStyles({
    frequentlyAskedQuestionSection: {
      padding: '48px 0',
      display: 'flex',
      flexDirection: 'column',
      gap: '40px',

      [theme.breakpoints.up('sm')]: {
        gap: '42px',
        padding: '64px 0',
      },
    },
    sectionHeader: {
      color: ({ headerVariant }: StyleProps) =>
        headerVariant === 'primary' ? theme.palette.primary.main : '#333333',
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: '24px',
      margin: 0,
      marginBottom: ({ headerVariant }: StyleProps) =>
        headerVariant === 'primary' ? 0 : '5px',
      textAlign: ({ headerVariant }: StyleProps) =>
        headerVariant === 'primary' ? 'center' : 'left',
      [theme.breakpoints.up('sm')]: {
        fontSize: '32px',
        lineHeight: '36px',
        fontWeight: 500,
      },
    },
    questionContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    question: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 500,
      margin: 0,
      textAlign: 'left',

      [theme.breakpoints.up('sm')]: {
        fontSize: '24px',
        lineHeight: '28px',
      },
    },
    collapsibleHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      borderRadius: 0,
      padding: 0,
      width: '100%',

      '&:hover': {
        background: 'none',
      },
    },
    collapsibleHeaderLabel: {
      justifyContent: 'space-between',
    },
    rotate: {
      transform: 'rotate(90deg)',
    },
    answer: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      color: '#666666',
      margin: 0,

      '& a': {
        color: '#377993',
        textDecoration: 'underline',
      },

      '& b': {
        color: '#000000',
        fontWeight: 400,
      },

      '& p': {
        margin: 0,
      },
    },
  })
)
